<loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>

@if (magicBlock) {
    <div class="flex flex-col gap-4 items-center justify-center">
        <div class="flex flex-col max-w-[95%] bg-ponder-light rounded shadow">
            <div class="flex flex-row gap-2 p-2 pb-1 text-slate-50">
                <magic-set-icon [setCode]="magicBlock!.code!" rarity="display"></magic-set-icon>
                <div>{{ magicBlock.name }} Block ({{ magicBlock.code | uppercase }})</div>
            </div>
            <div class="flex flex-row gap-2 text-xs text-slate-50 pl-2">
                <div>{{ releaseDate }}</div>
                <div>{{ totalCards | number }} cards</div>
            </div>
            <div class="rounded-b bg-slate-100">
                <div class="flex flex-col gap-2 pt-1 pb-1 rounded-b">
                    <table class="table-auto text-sm">
                        <thead class="text-left">
                            <th></th>
                            <th class=""></th>
                            <th class="pl-2">Set Name</th>
                            <th class="pl-2 pr-2">Code</th>
                            <th class="pl-2 pr-2 hidden sm:table-cell">Cards</th>
                            <th class="pr-4 hidden sm:table-cell">Released</th>
                        </thead>
                        <tbody>
                            @for (child of childSets; track child.id) {
                                <tr class="group hover:bg-ponder-linkhover hover:bg-opacity-15 border-t-[1px] cursor-pointer" [ngClass]="{ 'bg-slate-50' : $even }">
                                    <td class="pl-4 pt-[5px]"><input type="checkbox" (change)="onSetSelected(child.code!)"></td>
                                    <th class="sm:table-cell pt-1 pb-1 pl-2"><magic-set-icon [setCode]="child.code!" filterClass="filter-icon-ponder-xlight" [small]="true"></magic-set-icon></th>
                                    <td class="pl-2 sm:pr-6 truncate min-w-[25ch] sm:min-w-[60ch]" title="{{ child.name! }}" (click)="routeToSet(child)">{{ child.name }}</td>
                                    <td class="pl-2 pr-2 min-w-[8ch]">{{ child.code | uppercase }}</td>
                                    <td class="pl-2 pr-2 min-w-[8ch] sm:pr-6 hidden sm:table-cell">{{ child.cardCount | number }}</td>
                                    <td class="grow pr-4 min-w-[15ch] hidden sm:table-cell">{{ getReleaseDate(child.releaseDate!) }}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
                
                @if (allSelectedSets.length > 0) {
                    <div class="text-sm border-t-[1px] rounded-b">
                        <div (click)="onViewSelectedSets()" class="pl-4 pt-1 pb-1 hover:bg-ponder-linkhover hover:bg-opacity-15 cursor-pointer">
                            @if (allSelectedSets.length == 1) {
                                → View Selected Set
                            } @else {
                                → View Selected Sets ({{ allSelectedSets.length }})
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
}